import { SelectItem } from '@/components/ui/select';
import { cn } from '@/lib/utils';
import { useFonts } from '@/context/FontProvider';
import { SelectField } from './SelectField';

type Props = {
  value?: string;
  onChange?: (family: string) => void;
  className?: string;
};

const StylesFontFamilySettings = ({ value, onChange, className = 'max-w-[216px]' }: Props) => {
  const { fonts } = useFonts();

  const handleFontChange = (family: string) => {
    onChange?.(family);
  };

  return (
    <SelectField
      onValueChange={handleFontChange}
      className={cn(className)}
      defaultValue={value}
      placeholder="Font"
      size="small"
      text="Font"
    >
      {fonts.length > 0 ? (
        fonts.map((font) => (
          <SelectItem
            key={font.family}
            value={font.family}
            style={{
              fontFamily: font.family,
              fontSize: '14px',
              fontWeight: '400',
            }}
          >
            {font.family}
          </SelectItem>
        ))
      ) : (
        <SelectItem value="loading" disabled>
          Loading fonts...
        </SelectItem>
      )}
    </SelectField>
  );
};

export default StylesFontFamilySettings;
